import { FeedQueryResult, LightboxRootObject } from './softbox-types.ts';
import { resolvedLanguage } from '@/i18n.ts';
import {
  API_URL,
  DEFAULT_ASPECT,
  DEFAULT_CKEY,
  getInitializedMomentFetcher,
} from '@moment/net/fetch-contstants.ts';

export const generatePersonalizedFetchFeedQuery = (topInterests: string[]) => {
  return (options?: { lang?: string; logger?: any }) => {
    return async (): Promise<FeedQueryResult> => {
      const momentFetcher = await getInitializedMomentFetcher();
      const logger = options ? options.logger : undefined;
      logger?.log(
        `generatePersonalizedFetchFeedQuery, topInterests = ${topInterests}`
      );
      const lang = options ? options.lang : undefined;
      const language = lang || resolvedLanguage('en');
      // note - CMBU-2460 requested to change from trending to sched=personalizable
      // const trendingUrl = `${API_URL}/wp/v1/daily/trend?ckey=${DEFAULT_CKEY}&mp_lang=${language}&previewAspect=${DEFAULT_ASPECT}`;
      const whenNoPersonalizedFeed = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&sched=personalizable`;
      const personalizedUrl = `${API_URL}/wp/v1/personalization?ckey=${DEFAULT_CKEY}&mp_lang=${language}&previewAspect=${DEFAULT_ASPECT}&interests=${topInterests.join(',')}`;
      const url =
        topInterests.length > 0 ? personalizedUrl : whenNoPersonalizedFeed;
      const res = await momentFetcher.fetch(url, options);
      logger?.log(
        `generatePersonalizedFetchFeedQuery - hit\n${url}\nstatus=${res.status}`
      );
      const data: LightboxRootObject = await res.json();

      const resInterests = await momentFetcher.fetch(
        `${API_URL}/wp/v1/interests?ckey=${DEFAULT_CKEY}&previewAspect=${DEFAULT_ASPECT}`,
        options
      );
      logger?.log(
        `generatePersonalizedFetchFeedQuery - hit\n${url}\nstatus=${resInterests.status}`
      );
      const interests = await resInterests.json();
      const output = {
        news: data,
        interests,
      } satisfies FeedQueryResult;

      return output;
    };
  };
};
